import { css, SerializedStyles } from '@emotion/core';
import { Theme, secondaryText, normalText } from 'features/Theme';

const style = {
  headingContainer: (theme: Theme): SerializedStyles => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  body: (theme: Theme) => css`
    ${normalText(theme)}
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  disclosure: (theme: Theme) => css`
    margin-top: ${theme.mui.spacing(3)}px;
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  consent: (theme: Theme) => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  section: (theme: Theme) => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  captchaSection: (theme: Theme) => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  checkboxLabel: (theme: Theme): SerializedStyles => css`
    ${secondaryText(theme)}
  `,
  annualIncome: (theme: Theme) => css`
    ${secondaryText(theme)}
  `,
  restartText: (theme: Theme) => css`
    ${secondaryText(theme)}
  `,
  recaptchaMessage: (theme: Theme) => css`
    ${normalText(theme)};
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
};

export default style;
